// Registers the federated remotes; isolated so the MF runtime stays off the env.js read path.
import { registerRemotes } from '@module-federation/enhanced/runtime';

// Both remotes are statically imported in bootloader.js, so both are required to boot.
const RUNTIME_REMOTES = [
  { name: 'shipbob_design_system', settingKey: 'SHIPBOB_DESIGN_SYSTEM', required: true },
  { name: 'shipbob_mfe_runtime', settingKey: 'SHIPBOB_MFE_RUNTIME', required: true },
];

/** Registers every runtime remote from app settings; returns false if any required remote's URL was missing/invalid. */
export function registerRuntimeRemotes(appSettings) {
  const settings = appSettings || {};
  const missingRequired = [];

  RUNTIME_REMOTES.forEach(({ name, settingKey, required }) => {
    const value = settings[settingKey];
    if (typeof value !== 'string' || !value.trim()) {
      if (required) {
        missingRequired.push(settingKey);
      } else {
        console.error(`[payment_ui] ${settingKey} missing or invalid in app settings; skipping ${name} remote`);
      }
      return;
    }
    const origin = value.trim().endsWith('/') ? value.trim().slice(0, -1) : value.trim();
    registerRemotes([{ name, entry: `${origin}/remoteEntry.js` }], { force: true });
  });

  return missingRequired.length === 0;
}
